<template>
  <div class="polyline-box">
    <div
      v-if="(drawingProgress == 1 || drawingProgress == 2) && mouseX > -1"
      class="moving-pointer"
      :style="{ transform: 'translate3d(' + mouseX + 'px,' + mouseY + 'px,0)' }"
    >
      <span v-if="drawingProgress == 1">单击确认选点，ESC取消绘制</span>

      <span v-if="drawingProgress == 2 && mode == 1">单击确认框选矩形</span>
      <span v-if="drawingProgress == 2 && mode == 2">单击添加点位，双击结束绘制，ESC取消绘制</span>
    </div>
    <div
      class="polyline-mask"
      :class="{ 'cursor-crosshair': mode == 1, 'cursor-pointer': mode == 2 }"
      @click="addPointsStart"
    ></div>

    <!--  折线矩形 -->
    <div
      class="polyline-rect"
      :style="[
        rectStyle,
        { borderColor: vForm.color, borderWidth: vForm.width + 'px' },
        { cursor: drawingProgress == 3 ? 'default' : 'crosshair' },
      ]"
      @click="addPointsEnd"
    >
      <template v-if="drawingProgress == 3">
        <div
          class="drag-point drag-point-tl"
          :style="{ backgroundColor: vForm.color }"
          @mousedown="dragPointTLDown"
        ></div>
        <div
          class="drag-point drag-point-tr"
          :style="{ backgroundColor: vForm.color }"
          @mousedown="dragPointTRDown"
        ></div>
        <div
          class="drag-point drag-point-bl"
          :style="{ backgroundColor: vForm.color }"
          @mousedown="dragPointBLDown"
        ></div>
        <div
          class="drag-point drag-point-br"
          :style="{ backgroundColor: vForm.color }"
          @mousedown="dragPointBRDown"
        ></div>
        <div class="confirm-draw" @click="isShowPolylineData = true">确认绘制</div>
        <div class="cancel-draw" @click="cancelDraw">取消</div>
      </template>
    </div>

    <template v-if="drawingProgress >= 1 && mode == 2" class="polyline-click">
      <div
        v-for="(item, index) in points"
        :key="item.id"
        class="polyline-click-point"
        :class="{ last: index === points.length - 1 }"
        :style="{
          backgroundColor: vForm.color,
          left: item.x + 'px',
          top: item.y + 'px',
          height: vForm.width + 'px',
          width: item.w + 'px',
          transform: 'scaleX(' + item.s + ') rotate(' + item.r + 'deg)',
        }"
      >
        <div class="cap" :style="{ backgroundColor: vForm.color }"></div>
        <!-- <div v-else class="arrow" :style="{ borderColor: vForm.color }"></div> -->
      </div>
      <div
        v-if="drawingProgress == 3"
        class="confirm-draw-line"
        :style="{
          top: points[points.length - 1].y + 'px',
          left: points[points.length - 1].x + 'px',
        }"
        @click="isShowPolylineData = true"
      >
        确认绘制
      </div>
      <div
        v-if="drawingProgress == 3"
        class="cancel-draw-line"
        :style="{
          top: points[points.length - 1].y + 'px',
          left: points[points.length - 1].x + 90 + 'px',
        }"
        @click="cancelDraw"
      >
        取消
      </div>
    </template>

    <polyline-data
      v-if="isShowPolylineData"
      :show.sync="isShowPolylineData"
      :is-arrow-line="isArrowLine"
      @success="doSubmit"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import build from '../build';
import polylineData from './page-hedaer-polyline-data';

export default {
  components: { polylineData },
  props: {
    mode: {
      type: Number,
      default: 1,
    },
    isArrowLine: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isShowPolylineData: false,
      vForm: {
        color: 'rgba(248, 18, 18, 1)',
        width: 2,
        points: [],
      },
      rectStyle: {}, //折线框选样式
      drawingProgress: 1,
      mouseX: -1,
      mouseY: -1,
      mouseStartX: 0,
      mouseStartY: 0,
      adminList: [],
      adminLoading: false,
      doSubmitLoading: false,
      toolbarL: 0,
      toolbarT: 0,
      commentL: 0,
      commentT: 0,
      pointsTypeList: [],
      pointsTypeLoading: false,
      points: [],
      pointData: [],
      pointsClickTime: 0,
      ath: 0,
      atv: 0,
    };
  },

  computed: {
    ...mapState('tour', ['krp', 'sceneDetail', 'materialId']),
  },

  mounted() {
    this.addListenerMouseMove();
    this.addListenerMouseUp();
    this.handleKeyEsc();
    document.getElementById('app').setAttribute('style', 'overflow:hidden');
  },

  methods: {
    ...mapActions('tour', {
      actionGetSceneDetail: 'getSceneDetail',
    }),

    //绘制矩形
    drawRect(e) {
      let x = e.pageX;
      let y = e.pageY;
      let x_start = this.mouseStartX;
      let y_start = this.mouseStartY;
      let width = Math.abs(x - x_start);
      let height = Math.abs(y - y_start);
      let left = x_start;
      let top = y_start;
      if (x < x_start && y < y_start) {
        //左上
        left = x;
        top = y;
      }
      if (x < x_start && y > y_start) {
        //左下
        left = x_start - width;
        top = y_start;
      }
      if (x > x_start && y < y_start) {
        //右上
        left = x_start;
        top = y_start - height;
      }
      this.rectStyle = {
        display: 'block',
        width: width + 'px',
        height: height + 'px',
        left: left + 'px',
        top: top + 'px',
      };
      this.toolbarL = left + width + 13;
      this.toolbarT = top;
      this.commentL = left + width;
      this.commentT = top + 4;
    },

    //键盘点击ESC
    handleKeyEsc() {
      document.body.addEventListener('keydown', (e) => {
        if (e.keyCode == 27) {
          this.cancelDraw();
        }
      });
    },

    //取消绘制
    cancelDraw() {
      this.drawingProgress = '';
      this.krp.set('control.usercontrol', 'all');
      this.rectStyle = {};
      document.getElementById('app').removeAttribute('style');
      this.$emit('update:show', false);
      this.$emit('update:hide', false);
      this.removeListenerMouseMove();
      this.removeListenerMouseUp();
    },

    //添加折线点位-开始
    addPointsStart(e) {
      if (this.drawingProgress == 3) {
        return;
      }
      this.drawingProgress = this.drawingProgress == '' ? 1 : 2;
      this.mouseStartX = e.pageX;
      this.mouseStartY = e.pageY;
      if (this.mode == 1) {
        this.rectStyle = { display: 'block' };
      }
      if (this.mode == 2) {
        this.points.push({ x: e.pageX, y: e.pageY });
        if (
          (this.isArrowLine && this.points.length === 2) ||
          new Date() * 1 - this.pointsClickTime < 300
        ) {
          //双击操作
          this.drawingProgress = 3;
          this.toolbarL = Math.max.apply(
            null,
            this.points.map((item) => item.x)
          );
          this.toolbarT = Math.min.apply(
            null,
            this.points.map((item) => item.y)
          );
          this.commentL = this.points[this.points.length - 1].x;
          this.commentT = this.points[this.points.length - 1].y + 4;
        }
        this.pointsClickTime = new Date() * 1;
      }
    },

    //添加折线点位-开始
    addPointsEnd() {
      if (this.drawingProgress != 2) {
        return;
      }
      this.drawingProgress = 3;
    },

    //鼠标移动
    addListenerMouseMove() {
      document.body.addEventListener('mousemove', this.doMouseMove);
    },

    //鼠标移动
    removeListenerMouseMove() {
      document.body.removeEventListener('mousemove', this.doMouseMove);
    },

    //鼠标移动
    doMouseMove(e) {
      if (this.drawingProgress == 1 || this.drawingProgress == 2) {
        this.mouseX = e.pageX + 15;
        this.mouseY = e.pageY + 10;
      }
      if (this.mode == 1) {
        this.handleMouseMoveRect(e);
      }
      if (this.mode == 2) {
        this.handleMouseMoveClick(e);
      }
      if (this.toolbarDraging) {
        this.toolbarL = e.pageX - this.toolbarOffsetX - 10;
        this.toolbarT = e.pageY - this.toolbarOffsetY;
      }
      if (this.commentDraging) {
        this.commentL = e.pageX - this.commentOffsetX + this.$refs.commentPop.clientWidth / 2;
        this.commentT = e.pageY - this.commentOffsetY + this.$refs.commentPop.clientHeight;
      }
    },

    //框选绘制
    handleMouseMoveRect(e) {
      if (this.drawingProgress == 2) {
        this.drawRect(e);
      }
      if (this.dragPointTLDraging) {
        this.rectStyle.left = Math.min(e.pageX, this.rect.l + this.rect.w - 30) + 'px';
        this.rectStyle.top = Math.min(e.pageY, this.rect.t + this.rect.h - 30) + 'px';
        this.rectStyle.width = Math.max(this.rect.w - (e.pageX - this.dragPointStartX), 30) + 'px';
        this.rectStyle.height = Math.max(this.rect.h - (e.pageY - this.dragPointStartY), 30) + 'px';
      }
      if (this.dragPointTRDraging) {
        this.rectStyle.top = Math.min(e.pageY, this.rect.t + this.rect.h - 30) + 'px';
        this.rectStyle.width = Math.max(this.rect.w + (e.pageX - this.dragPointStartX), 30) + 'px';
        this.rectStyle.height = Math.max(this.rect.h - (e.pageY - this.dragPointStartY), 30) + 'px';
      }
      if (this.dragPointBLDraging) {
        this.rectStyle.left = Math.min(e.pageX, this.rect.l + this.rect.w - 30) + 'px';
        this.rectStyle.width = Math.max(this.rect.w - (e.pageX - this.dragPointStartX), 30) + 'px';
        this.rectStyle.height = Math.max(this.rect.h + (e.pageY - this.dragPointStartY), 30) + 'px';
      }
      if (this.dragPointBRDraging) {
        this.rectStyle.width = Math.max(this.rect.w + (e.pageX - this.dragPointStartX), 30) + 'px';
        this.rectStyle.height = Math.max(this.rect.h + (e.pageY - this.dragPointStartY), 30) + 'px';
      }
    },

    //点选绘制
    handleMouseMoveClick(e) {
      if (this.drawingProgress == 2) {
        let point = this.points[this.points.length - 1];
        let dx = e.pageX - point.x;
        let dy = e.pageY - point.y;
        point.w = Math.sqrt(Math.pow(Math.abs(dx), 2) + Math.pow(Math.abs(dy), 2));
        point.s = dx >= 0 ? '1' : '-1';
        point.r = Math.asin(dy / point.w) / (Math.PI / 180);
      }
    },

    //鼠标抬起
    addListenerMouseUp() {
      document.body.addEventListener('mouseup', this.doMouseUp);
    },

    //鼠标抬起
    removeListenerMouseUp() {
      document.body.removeEventListener('mouseup', this.doMouseUp);
    },

    //鼠标抬起
    doMouseUp() {
      this.toolbarDraging = false;
      this.commentDraging = false;
      this.dragPointTLDraging = false;
      this.dragPointTRDraging = false;
      this.dragPointBLDraging = false;
      this.dragPointBRDraging = false;
    },

    //矩形大小调整拖动-左上
    dragPointTLDown(e) {
      this.dragPointTLDraging = true;
      this.dragPointStartX = e.pageX;
      this.dragPointStartY = e.pageY;
      this.rect = {
        w: parseInt(this.rectStyle.width),
        h: parseInt(this.rectStyle.height),
        l: parseInt(this.rectStyle.left),
        t: parseInt(this.rectStyle.top),
      };
    },

    //矩形大小调整拖动-右上
    dragPointTRDown(e) {
      this.dragPointTRDraging = true;
      this.dragPointStartX = e.pageX;
      this.dragPointStartY = e.pageY;
      this.rect = {
        w: parseInt(this.rectStyle.width),
        h: parseInt(this.rectStyle.height),
        l: parseInt(this.rectStyle.left),
        t: parseInt(this.rectStyle.top),
      };
    },

    //矩形大小调整拖动-左下
    dragPointBLDown(e) {
      this.dragPointBLDraging = true;
      this.dragPointStartX = e.pageX;
      this.dragPointStartY = e.pageY;
      this.rect = {
        w: parseInt(this.rectStyle.width),
        h: parseInt(this.rectStyle.height),
        l: parseInt(this.rectStyle.left),
        t: parseInt(this.rectStyle.top),
      };
    },

    //矩形大小调整拖动-右下
    dragPointBRDown(e) {
      this.dragPointBRDraging = true;
      this.dragPointStartX = e.pageX;
      this.dragPointStartY = e.pageY;
      this.rect = {
        w: parseInt(this.rectStyle.width),
        h: parseInt(this.rectStyle.height),
        l: parseInt(this.rectStyle.left),
        t: parseInt(this.rectStyle.top),
      };
    },

    //计算球坐标
    calculatePointsRect(ext) {
      let x = parseInt(this.rectStyle.left);
      let y = parseInt(this.rectStyle.top);
      let w = parseInt(this.rectStyle.width);
      let h = parseInt(this.rectStyle.height);
      let x1 = x,
        y1 = y,
        x2 = x + w,
        y2 = y,
        x3 = x + w,
        y3 = y + h,
        x4 = x,
        y4 = y + h;
      let x5 = x1 + (x2 - x1) / 2;
      let y5 = y1 + (y3 - y1) / 2;
      let x6 = ext && ext.width ? x1 + ext.width / 2 : x1;
      let y6 = y1;
      this.krp.call(`set(x1,${x1})`);
      this.krp.call(`set(y1,${y1})`);
      this.krp.call(`set(x2,${x2})`);
      this.krp.call(`set(y2,${y2})`);
      this.krp.call(`set(x3,${x3})`);
      this.krp.call(`set(y3,${y3})`);
      this.krp.call(`set(x4,${x4})`);
      this.krp.call(`set(y4,${y4})`);
      this.krp.call(`set(x5,${x5})`);
      this.krp.call(`set(y5,${y5})`);
      this.krp.call(`set(x6,${x6})`);
      this.krp.call(`set(y6,${y6})`);
      this.krp.call(`screentosphere(x1,y1,h1,v1)`);
      this.krp.call(`screentosphere(x2,y2,h2,v2)`);
      this.krp.call(`screentosphere(x3,y3,h3,v3)`);
      this.krp.call(`screentosphere(x4,y4,h4,v4)`);
      this.krp.call(`screentosphere(x5,y5,h5,v5)`);
      this.krp.call(`screentosphere(x6,y6,h6,v6)`);
      let h1 = this.krp.get(`h1`);
      let v1 = this.krp.get(`v1`);
      let h2 = this.krp.get(`h2`);
      let v2 = this.krp.get(`v2`);
      let h3 = this.krp.get(`h3`);
      let v3 = this.krp.get(`v3`);
      let h4 = this.krp.get(`h4`);
      let v4 = this.krp.get(`v4`);
      let h5 = this.krp.get(`h5`);
      let v5 = this.krp.get(`v5`);
      let h6 = this.krp.get(`h6`);
      let v6 = this.krp.get(`v6`);
      this.pointData = [
        { ath: h1, atv: v1 },
        { ath: h2, atv: v2 },
        { ath: h3, atv: v3 },
        { ath: h4, atv: v4 },
        { ath: h6, atv: v6 },
      ];
      this.ath = h5;
      this.atv = v5;
    },

    calculatePointsClick() {
      this.vForm.points = [];
      let xs = this.points.map((item) => item.x);
      let ys = this.points.map((item) => item.y);
      let xMin = Math.min.apply(null, xs);
      let xMax = Math.max.apply(null, xs);
      let yMin = Math.min.apply(null, ys);
      let yMax = Math.max.apply(null, ys);
      let xc = xMin + (xMax - xMin) / 2;
      let yc = yMin + (yMax - yMin) / 2;
      this.points.forEach((item, index) => {
        this.krp.call(`set(x${index},${item.x})`);
        this.krp.call(`set(y${index},${item.y})`);
        this.krp.call(`screentosphere(x${index},y${index},h${index},v${index})`);
        this.pointData.push({
          ath: this.krp.get(`h${index}`),
          atv: this.krp.get(`v${index}`),
        });
      });
      this.krp.call(`set(xc,${xc})`);
      this.krp.call(`set(yc,${yc})`);
      this.krp.call(`screentosphere(xc,yc,hc,vc)`);
      this.ath = this.krp.get('hc');
      this.atv = this.krp.get('vc');
    },

    //提交折线
    async doSubmit(res) {
      this.doSubmitLoading = true;
      try {
        if (this.mode == 1) {
          this.calculatePointsRect(res);
        }
        if (this.mode == 2) {
          this.calculatePointsClick(res);
        }
        let res2 = await this.api.point.add({
          materialId: this.materialId,
          name: res.name,
          pointData: this.pointData,
          ath: this.ath,
          atv: this.atv,
          ext: {
            color: res.color,
            width: res.width,
            isLine: res.isLine,
            arrow: res.arrow,
            dotted: res.dotted,
            rotate: this.points[0] && this.points[0].r ? this.points[0].r : 0,
          },
        });
        let res3 = await this.api.spot.add({
          materialId: this.materialId,
          title: res.name,
          ath: this.ath,
          atv: this.atv,
          width: 30,
          height: 30,
          ext: {
            iconTxtColor: '#fff',
            iconTxtBgColor: '#ff0000',
            iconTxtRadius: 4,
            iconTxtPadding: 4,
          },
          imageType: 4,
          fromName: '',
          fromId: '',
          url: '',
          fontSize: 16,
          mFontSize: 12,
          vrType: 1,
        });
        await this.actionGetSceneDetail({ materialId: this.materialId });
        this.renderDrawing(
          res3.data.id,
          res2.data.id,
          Object.assign(res, { rotate: this.points[0] && this.points[0].r ? this.points[0].r : 0 })
        );
        this.$message.success('提交成功');
        this.cancelDraw();
      } catch (e) {
        console.error(e);
      }
      this.doSubmitLoading = false;
    },

    renderDrawing(hotspotId, polylineId, res) {
      let hotspot = {
        id: hotspotId,
        ath: this.ath,
        atv: this.atv,
        title: res.name,
        imageType: 4,
        width: 30,
        height: 30,
        ext: {
          iconTxtColor: '#fff',
          iconTxtBgColor: '#ff0000',
          iconTxtRadius: 4,
          iconTxtPadding: 4,
        },
        fromName: '',
        fromId: '',
        url: '',
        fontSize: 16,
        mFontSize: 12,
        vrType: 1,
        // imagePreview: 'https://vybbasevr.vyb.cn/1af0e812_152b_4653_aafa_6801db6027d11632360011781',
        isMobile: this.isMobile,
      };
      build.renderPolyline(
        this.krp,
        {
          id: polylineId,
          pointData: this.pointData,
          ext: res,
        },
        this.sceneDetail.pointList.length - 1
      );
      // build.rednerHotspot(this.krp, hotspot);
      build.rednerHotspotText(this.krp, hotspot);
      // build.renderHotspotPlaceholder(this.krp, hotspot);
      build.renderHotspotEdit(this.krp, hotspot);
      build.renderHotspotDelete(this.krp, hotspot);
      // build.renderHotspotTitle(this.krp, hotspot);
    },
  },
};
</script>

<style scoped>
.polyline-box {
  position: absolute;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.polyline-mask {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.polyline-mask.cursor-crosshair {
  cursor: crosshair;
}

.polyline-mask.cursor-pointer {
  cursor: pointer;
}

.moving-pointer {
  position: absolute;
  border: 1px solid #df8459;
  background: #fff;
  padding: 0 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 20;
}

.polyline-rect {
  position: absolute;
  z-index: 10;
  box-shadow: 0 0 0 10000px rgba(0, 0, 0, 0.4);
  display: none;
  border: 2px solid #f81212;
  cursor: crosshair;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
}

.polyline-toolbar {
  position: absolute;
  z-index: 10;
  background: #fff;
  left: 0;
  top: 0;
  transform: translate(13px, 0);
  width: 420px;
}

.name-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.name-list .item {
  height: 25px;
  line-height: 25px;
  background: #f1f1f1;
  margin-right: 10px;
  font-size: 13px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #fff;
}

.name-list .item.active {
  border: 1px solid #409eff;
  color: #409eff;
}

.color-box {
  display: flex;
  align-content: center;
  margin-top: 10px;
}

.color-box .color-item {
  width: 25px;
  height: 25px;
  border-radius: 4px;
  margin-right: 10px;
  cursor: pointer;
}

.color-box .color-item:last-child {
  margin-right: 0;
}

.polyline-toolbar-header {
  height: 50px;
  display: flex;
  align-items: center;
  background: #eee;
  padding: 0 10px;
  margin-bottom: 20px;
  font-weight: bold;
  cursor: move;
  user-select: none;
  position: relative;
}

.polyline-toolbar-header-cover {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.polyline-toolbar-header span {
  font-size: 12px;
  color: red;
  margin-left: 5px;
  font-weight: normal;
}

.polyline-toolbar-footer {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background: #eee;
  padding: 0 10px;
}

.comment-pop {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: move;
  z-index: 20;
  transform: translate(-50%, -100%);
}

.comment-pop .content {
  font-size: 12px;
  padding: 10px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.8);
  user-select: none;
}

.comment-pop .icon {
  width: 10px;
  display: flex;
}

.drag-point {
  position: absolute;
  width: 8px;
  height: 8px;
  border: 1px solid #fff;
}

.drag-point-tl {
  left: 0;
  top: 0;
  transform: translate(-50%, -50%);
  cursor: nwse-resize;
}

.drag-point-tr {
  right: 0;
  top: 0;
  transform: translate(50%, -50%);
  cursor: nesw-resize;
}

.drag-point-bl {
  left: 0;
  bottom: 0;
  transform: translate(-50%, 50%);
  cursor: nesw-resize;
}

.drag-point-br {
  right: 0;
  bottom: 0;
  transform: translate(50%, 50%);
  cursor: nwse-resize;
}

.polyline-click-point {
  position: absolute;
  transform-origin: left center;
}

.polyline-click-point .cap {
  position: absolute;
  width: 8px;
  height: 8px;
  border: 1px solid #fff;
  left: 0;
  top: 0;
  transform: translate(-50%, -50%);
}
.polyline-click-point .arrow {
  position: absolute;
  left: 0;
  top: 0;
  border-top: 4px solid transparent !important;
  border-bottom: 4px solid transparent !important;
  border-right: 8px solid #000;
}

.polyline-click-point.last .arrow {
  border-left: 8px solid #000;
}

.confirm-draw {
  position: absolute;
  right: -10px;
  bottom: 0;
  transform: translate(100%, 0);
  padding: 10px 0;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  width: 80px;
  text-align: center;
  z-index: 10;
  background: #67c23a;
  color: #fff;
}

.cancel-draw {
  position: absolute;
  right: -100px;
  bottom: 0;
  transform: translate(100%, 0);
  padding: 10px 0;
  background: #fff;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  width: 80px;
  text-align: center;
  z-index: 10;
}

.confirm-draw-line {
  position: absolute;
  padding: 10px 0;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  width: 80px;
  text-align: center;
  z-index: 10;
  transform: translate(10px, -50%);
  background: #67c23a;
  color: #fff;
}

.cancel-draw-line {
  position: absolute;
  padding: 10px 0;
  background: #fff;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  width: 80px;
  text-align: center;
  z-index: 10;
  transform: translate(10px, -50%);
}
</style>
